import { isNil } from 'lodash-es';

export async function copyText(text?: string): Promise<boolean> {
  if (isNil(text)) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (ex) {
    console.error(ex);

    if (import.meta.env.DEV) {
      // In dev mode, we're not in a secure context, so can't use navigator.clipboard
      const textField = document.createElement('textarea');
      textField.innerHTML = text;
      document.body.appendChild(textField);
      textField.select();
      const copied = document.execCommand('copy');
      textField.remove();
      return copied;
    }

    return false;
  }
}
